import {
  RENTER_DOWNLOADED,
  RENTER_SENDING,
  RENTERS_DOWNLOADED,
  RENTERS_FAILED,
  RENTERS_PENDING,
  RENTERS_RESET,
  RENTER_REMOVED,
} from './types';
import RentersApiService from '../../services/api/RentersApiService';
import { handleError } from '../infos/actions';

export const rentersResetAction = () => ({
  type: RENTERS_RESET,
});

export const renterSendingAction = () => ({
  type: RENTER_SENDING,
});

export const rentersPendingAction = () => ({
  type: RENTERS_PENDING,
});

export const renterDeletedAction = (renterId) => ({
  type: RENTER_REMOVED,
  payload: renterId,
});

export const rentersDownloadedAction = (renters) => ({
  type: RENTERS_DOWNLOADED,
  payload: renters,
});

export const renterDownloadedAction = (renter) => ({
  type: RENTER_DOWNLOADED,
  payload: renter,
});

export const rentersFailedAction = (error) => ({
  type: RENTERS_FAILED,
  payload: error,
});

// Actions

export function resetRenters() {
  return (dispatch) => {
    dispatch(rentersResetAction());
  };
}

export function getRenters(authUserToken, role) {
  return (dispatch) => {
    dispatch(rentersPendingAction());
    return RentersApiService
      .getRenters(authUserToken, role)
      .then((data) => {
        dispatch(rentersDownloadedAction(data));
      })
      .catch((error) => {
        dispatch(rentersFailedAction(error));
        dispatch(handleError(error));
      });
  };
}

export function postRenter(authUserToken, renter) {
  return (dispatch) => {
    dispatch(renterSendingAction());
    return RentersApiService
      .postAdminRenters(authUserToken, renter)
      .then((data) => {
        dispatch(renterDownloadedAction(data));
        return data.id;
      })
      .catch((error) => {
        dispatch(rentersFailedAction(error));
        dispatch(handleError(error));
        return null;
      });
  };
}

export function postRenterPicture(authUserToken, renterId, picture, onUploadProgress = null) {
  return (dispatch) => {
    dispatch(renterSendingAction());
    return RentersApiService
      .postAdminRentersPicture(authUserToken, renterId, picture, onUploadProgress)
      .then((data) => {
        dispatch(renterDownloadedAction(data));
        return data;
      })
      .catch((error) => {
        dispatch(rentersFailedAction(error));
        dispatch(handleError(error));
        return null;
      });
  };
}

export function putRenter(authUserToken, renter) {
  return (dispatch) => {
    dispatch(renterSendingAction());
    return RentersApiService
      .putAdminRenters(authUserToken, renter)
      .then((data) => {
        dispatch(renterDownloadedAction(data));
        return data.id;
      })
      .catch((error) => {
        dispatch(rentersFailedAction(error));
        dispatch(handleError(error));
        return null;
      });
  };
}

export function deleteRenter(authUserToken, renterId) {
  return (dispatch) => {
    dispatch(renterSendingAction());
    return RentersApiService
      .deleteAdminRenters(authUserToken, renterId)
      .then(() => {
        dispatch(renterDeletedAction(renterId));
        return renterId;
      })
      .catch((error) => {
        dispatch(rentersFailedAction(error));
        dispatch(handleError(error));
        return null;
      });
  };
}



// WEBPACK FOOTER //
// ./src/store/renters/actions.js